export const isWeixin = () => {
    return /MicroMessenger/.test(window.navigator.userAgent)
}
export const isIOS = () => {
    return /Mac OS/.test(window.navigator.userAgent)
}
export const isMobile = () => {
    return /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)
}
